import { Button, Callout } from '@dev-spendesk/grapes';

import {
  type TGlobalFunctionTyped,
  useTranslation,
} from 'src/core/common/hooks/useTranslation';

type Props = {
  onClick: () => void;
  lineSplitConfiguration: { sendOnHeader: boolean; sendOnLine: boolean };
};

const getTranslations = (
  isWarning: boolean,
  t: TGlobalFunctionTyped,
): {
  variant: 'warning' | 'info';
  title: string;
  message: string;
} => {
  if (isWarning) {
    return {
      variant: 'warning',
      title: t('company.reviewLineSplitSettingsCallout.warning.title'),
      message: t('company.reviewLineSplitSettingsCallout.warning.message'),
    };
  }

  return {
    variant: 'info',
    title: t('company.reviewLineSplitSettingsCallout.info.title'),
    message: t('company.reviewLineSplitSettingsCallout.info.message'),
  };
};

export const ReviewLineSplitSettingsWarning = ({
  onClick,
  lineSplitConfiguration,
}: Props) => {
  const { t } = useTranslation('global');

  const isWarning =
    lineSplitConfiguration.sendOnHeader && !lineSplitConfiguration.sendOnLine;
  const trs = getTranslations(isWarning, t);

  return (
    <Callout className="my-16" title={trs.title} variant={trs.variant}>
      <p className="mb-8">{trs.message}</p>
      <Button
        variant="secondaryNeutral"
        text={t('company.reviewLineSplitSettingsCallout.cta.reviewUpdates')}
        onClick={onClick}
      />
      <Button
        variant="tertiaryNeutral"
        text={t('company.reviewLineSplitSettingsCallout.cta.keepCurrent')}
      />
    </Callout>
  );
};
